/**
 * Admin portal auth context — delegates to the shared AuthProvider.
 *
 * With Managed Login, the admin portal uses the same OAuth-only flow as all
 * other portals. The only difference is the identity_provider is set to 'Google'
 * and a legacy token prefix is used for backward compatibility cleanup.
 */

import { ReactNode } from 'react'
import { AuthProvider as SharedAuthProvider, useAuth, type AuthProviderConfig } from '@brent/shared'

export { useAuth }

// Re-export the context type for consumers that need it
export type { AuthContextType } from '@brent/shared'

const adminConfig: AuthProviderConfig = {
  userPoolId: import.meta.env.VITE_ADMIN_COGNITO_USER_POOL_ID,
  clientId: import.meta.env.VITE_ADMIN_COGNITO_CLIENT_ID,
  region: import.meta.env.VITE_ADMIN_COGNITO_REGION || 'eu-west-1',
  domain: import.meta.env.VITE_ADMIN_COGNITO_DOMAIN,
  redirectUri: import.meta.env.VITE_ADMIN_COGNITO_REDIRECT_URI,
  logoutUri: import.meta.env.VITE_ADMIN_COGNITO_LOGOUT_URI ?? window.location.origin,
  identityProvider: 'Google',
  legacyTokenPrefix: 'admin',
}

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  return <SharedAuthProvider config={adminConfig}>{children}</SharedAuthProvider>
}
